import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import NetworkSummary from "../components/dashboard/NetworkSummary";
import IncentiveSummary from "../components/dashboard/IncentiveSummary";
import ReferralInfo from "../components/dashboard/ReferralInfo";
import VirtualCard from "../components/dashboard/VirtualCard";
import MarketingOfferModal from "../components/dashboard/MarketingOfferModal";
import api from "../services/api";

const container = {
  hidden: { opacity: 0, y: 16 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, staggerChildren: 0.1 },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.35 } },
};

const SHOW_ONCE_PER_SESSION = false;
const MARKETING_SESSION_KEY = "rmc2.marketingOfferSeen";

const Dashboard = () => {
  const navigate = useNavigate();
  const [isMarketingOpen, setIsMarketingOpen] = useState(false);
  const [marketingProduct, setMarketingProduct] = useState(null);

  useEffect(() => {
    let timeoutId;

    const fetchOffer = async () => {
      try {
        if (SHOW_ONCE_PER_SESSION && sessionStorage.getItem(MARKETING_SESSION_KEY)) {
          return;
        }

        const token = localStorage.getItem("rmc2.access_token");
        if (!token) {
          return;
        }

        const response = await api.get("/marketing-offer", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data?.status !== "success") {
          return;
        }

        const data = response.data?.data || {};
        if (!data.eligible || !data.product) {
          return;
        }

        setMarketingProduct(data.product);
        timeoutId = setTimeout(() => {
          setIsMarketingOpen(true);
          if (SHOW_ONCE_PER_SESSION) {
            sessionStorage.setItem(MARKETING_SESSION_KEY, "1");
          }
        }, 2000);
      } catch (error) {
        return;
      }
    };

    fetchOffer();

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  return (
    <>
      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="mx-auto flex w-full max-w-[1400px] flex-col gap-6"
      >
        <motion.div variants={item} className="rounded-3xl border border-white/60 bg-white/80 p-6 shadow-lg shadow-slate-200/60">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-400">
            Welcome Back
          </p>
          <div className="mt-3 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <h1 className="text-3xl font-semibold text-slate-900">
                Dashboard Overview
              </h1>
              <p className="mt-2 max-w-2xl text-sm text-slate-500">
                Track your network performance, referral activity, incentives,
                and virtual card status in one place.
              </p>
            </div>
            <div className="flex items-center gap-3">
              {/* <div className="rounded-2xl bg-blue-100 px-4 py-3 text-sm font-semibold text-[var(--brand-blue)]">
                Active Cycle: March 2026
              </div>
              <button
                type="button"
                className="rounded-2xl bg-[var(--brand-orange)] px-4 py-3 text-sm font-semibold text-white shadow-lg shadow-orange-200 transition hover:bg-[var(--brand-orange-dark)]"
              >
                View Insights
              </button> */}
            </div>
          </div>
        </motion.div>

        <div className="grid gap-6 lg:grid-cols-[1.4fr_0.9fr]">
          <motion.div variants={item} className="flex flex-col gap-6">
            <NetworkSummary />
            <IncentiveSummary />
          </motion.div>
          <motion.div variants={item} className="flex flex-col gap-6">
            <ReferralInfo />
            <VirtualCard />
          </motion.div>
        </div>
      </motion.div>

      <MarketingOfferModal
        open={isMarketingOpen}
        product={marketingProduct}
        onClose={() => setIsMarketingOpen(false)}
        onViewProducts={() => {
          setIsMarketingOpen(false);
          navigate("/products");
        }}
      />
    </>
  );
};

export default Dashboard;
